import { InsuranceProduct } from "Store/interfaces/products/checkout";
import React from "react";
import { CardHeader } from "../CardHeader";
import { DetailsCardWrapper } from "../styled";
import { EditableCardFooter } from "./EditableCardFooter";

interface Props {
  onRemoveProduct: (products: InsuranceProduct[]) => void;
  readonly product: InsuranceProduct;
  readonly additionalProduct?: InsuranceProduct;
}

export const EditableInsuranceDetailsCard = ({
  onRemoveProduct,
  product,
  additionalProduct,
}: Props): React.ReactElement => {
  return (
    <DetailsCardWrapper insuranceDetailsCard padding="16px 16px 8px 16px">
      <CardHeader product={product} productIcon />
      <EditableCardFooter
        onRemoveProduct={onRemoveProduct}
        product={product}
        additionalProduct={additionalProduct}
      />
    </DetailsCardWrapper>
  );
};
